import apiClient from './api/client';
import { apiEndpoints } from './api/endpoints';
import type { 
  Customer, 
  CustomerProfile, 
  CustomerAddress, 
  CreateAddressRequest, 
  UpdateAddressRequest,
  UpdateCustomerRequest,
  UpdateCustomerProfileRequest
} from '../types/user.types';

export const userService = {
  // Create customer (for new OAuth users)
  createCustomer: async (sub: string, email: string, name?: string, phone?: string) => {
    const response = await apiClient.post<Customer>(apiEndpoints.customers.root(), {
      sub,
      email,
      name,
      phone
    });
    return response.data;
  },

  // Customer APIs
  getCustomer: async (customerId: string) => {
    const response = await apiClient.get<Customer>(apiEndpoints.customers.get(customerId));
    return response.data;
  },

  updateCustomer: async (customerId: string, data: UpdateCustomerRequest) => {
    const response = await apiClient.put<Customer>(apiEndpoints.customers.get(customerId), data);
    return response.data;
  },

  // Customer Profile APIs
  getCustomerProfile: async (customerId: string) => {
    const response = await apiClient.get<{ profile: CustomerProfile }>(apiEndpoints.customers.profile(customerId));
    return response.data;
  },

  updateCustomerProfile: async (customerId: string, data: UpdateCustomerProfileRequest) => {
    const response = await apiClient.put<{ profile: CustomerProfile }>(apiEndpoints.customers.updateProfile(customerId), data);
    return response.data;
  },

  // Customer Address APIs
  getAddresses: async (customerId: string) => {
    const response = await apiClient.get<CustomerAddress[]>(apiEndpoints.customers.addresses(customerId));
    return response.data;
  },

  createAddress: async (customerId: string, data: CreateAddressRequest) => {
    const response = await apiClient.post<CustomerAddress>(apiEndpoints.customers.addresses(customerId), data);
    return response.data;
  },

  updateAddress: async (customerId: string, addressId: string, data: UpdateAddressRequest) => {
    const response = await apiClient.put<CustomerAddress>(apiEndpoints.customers.address(customerId, addressId), data);
    return response.data;
  },

  deleteAddress: async (customerId: string, addressId: string) => {
    await apiClient.delete(apiEndpoints.customers.address(customerId, addressId));
  },

  // Legacy methods (for backwards compatibility)
  getProfile: async () => {
    const response = await apiClient.get('/user/profile');
    return response.data;
  },

  updateProfile: async (data: unknown) => {
    const response = await apiClient.put('/user/profile', data);
    return response.data;
  }
};
